import { client } from '../graphql/client';
import { getUserInfo, isLoggedIn } from './auth';
import {
  CHECK_GRAYSCALE_DRIVER,
  CheckGrayscaleDriverResponse,
  CheckGrayscaleDriverVariables,
} from '../pages/delivery/graphql/queries/checkGrayscaleDriver';


// localStorage key
const GRAYSCALE_STORAGE_KEY = 'nativeDeliveryDriverGrayscaleEnabled'
const TEMPORARY_GRAY_KEY = 'delivery.temporary.driverIds';
export const WEB_TEMPORARY_GRAY_ENABLED = 'webTemporaryGrayEnabled';


/**
 * 检查当前登录的配送司机是否在灰度列表中
 * @param configKey 配置键，默认为 "delivery.off_line_map_gray.driver_ids"
 * @returns Promise<boolean | null> - 如果在灰度列表中返回 true，否则返回 false，如果用户不是配送司机或未登录则返回 null
 */
export const checkGrayscaleDriver = async (
  configKey: string = 'delivery.native_app.driver_ids'
): Promise<boolean | null> => {
  const userInfo = getUserInfo();
  const role = userInfo?.account?.role?.name;

  // 检查是否已登录且角色为配送司机
  if (!isLoggedIn() || role !== 'DELIVERY_DRIVER') {
    return null;
  }

  try {
    const { data, errors } = await client.query<
      CheckGrayscaleDriverResponse,
      CheckGrayscaleDriverVariables
    >({
      query: CHECK_GRAYSCALE_DRIVER,
      variables: {
        configKey,
      },
      errorPolicy: 'all',
    });

    const isEnabled = data?.checkGrayscaleDriver;
    // 存储到 localStorage
    localStorage.setItem(GRAYSCALE_STORAGE_KEY, String(isEnabled));

    if (errors) {
      localStorage.removeItem(GRAYSCALE_STORAGE_KEY);
      return false;
    }

    return data?.checkGrayscaleDriver ?? false;
  } catch (error) {
    localStorage.removeItem(GRAYSCALE_STORAGE_KEY);
    return false;
  }
};


/**
 * 检查当前登录的配送司机是否在临时灰度(driverIds)列表中
 * @description key为'delivery.temporary.driverIds'，无返回值，localStorageKey为'webTemporaryGrayEnabled'
 */
export const checkTemporaryGrayDriver = async (): Promise<void> => {
  const userInfo = getUserInfo();
  const role = userInfo?.account?.role?.name;

  if (!isLoggedIn() || role !== 'DELIVERY_DRIVER') {
    localStorage.removeItem(WEB_TEMPORARY_GRAY_ENABLED);
    return;
  }

  try {
    const { data, errors } = await client.query<
      CheckGrayscaleDriverResponse,
      CheckGrayscaleDriverVariables
    >({
      query: CHECK_GRAYSCALE_DRIVER,
      variables: {
        configKey: TEMPORARY_GRAY_KEY,
      },
      errorPolicy: 'all',
    });

    const isEnabled = data?.checkGrayscaleDriver;
    console.log("checkTemporaryGrayDriver#checkTemporaryGrayDriver:", isEnabled);
    if (isEnabled) {
      localStorage.setItem(WEB_TEMPORARY_GRAY_ENABLED, 'true');
    } else {
      localStorage.removeItem(WEB_TEMPORARY_GRAY_ENABLED);
    }
    if (errors) {
      localStorage.removeItem(WEB_TEMPORARY_GRAY_ENABLED);
    }
  } catch (error) {
    localStorage.removeItem(WEB_TEMPORARY_GRAY_ENABLED);
  }
};
